import axios from 'axios';
import { assign } from 'lodash';

import * as types from '../types';
import { getGoodsDetail } from '~/api/member';
import {
  getUserAddress,
  getMemberGoodsPayment,
  vipList,
  getGoodsCoupinsList,
} from '~/api/index';
import { getMemberInfo } from '~/api/user';
import { getCookie } from '~/utils/index';

export const state = () => {
  return {
    show: false,
    data: null,
    specsId: null,
    info: {
      chooseCoupon: '',
      couponList: [],
      vipGoodId: null,
      vipDiscount: null,
      displayButtonText: null,
      memberPrice: 0,
      payInfo: {
        // 商品结算数据
        goods: [],
        packageSpecsId: null, // 实际结算商品
        total: null, // 应付金额
        vipDiscount: null, // 会员减免优惠
      },
      paymethod: 'wechat',
      memberSpecsId: null,
      userToken: '',
      publicKey: '4zG9ZXqTQCX6vJqMLeVHAJHQ6sePEPwM',
      address: {
        name: '',
        phone: '',
        address: '',
        temp: {
          state: '',
          city: '',
          dist: '',
        },
      },
    },
    userCoin: 0,
  };
};

export const getters = {
  dialogShow: state => {
    return state.show;
  },
  dialogData: state => {
    return state.data;
  },
  specsId: state => {
    return state.specsId;
  },
  info: state => {
    return state.info;
  },
  userCoin: state => {
    return state.userCoin;
  },
};

export const mutations = {
  /**
   * @description 设置订单展示
   * @param { Object } state 操作对象
   * @param { Boolean } val 更新状态
   */
  [types.SET_ORDER_SHOW](state, val) {
    state.show = val;
  },
  /**
   * @description 订单数据
   * @param { Object } state 操作对象
   * @param { Object } val 更新数据
   */
  [types.SET_ORDER_DATA](state, val) {
    state.data = val;
  },
  /**
   * @description 设置订单 id
   * @param { Object } state 操作对象
   * @param { Object } val 更新值
   */
  [types.SET_ORDER_SPECSID](state, val) {
    state.specsId = val;
  },
  /**
   * @description 设置订单信息
   * @param { Object } state 操作对象
   * @param { Object } val 更新值
   */
  [types.SET_ORDER_INFO](state, query) {
    // TIP: remove lodash
    assign(state.info, query);
  },
  /**
   * @description 设置用户格隆贝
   * @param { Object } state 操作对象
   * @param { number } val 更新值
   */
  [types.SET_USER_COIN](state, val) {
    state.userCoin = val;
  },
};

export const actions = {
  /**
   * @description 更新弹窗展示状态
   * @param { Object } param0 操作对象
   * @param { Boolean } val 修改状态值
   */
  updateShowStatus({ commit }, val) {
    commit(types.SET_ORDER_SHOW, val);
  },

  /**
   * @description 更新数据
   * @param { Object } param0 操作对象
   * @param { Boolean } val 修改数据
   */
  updateData({ commit }, val) {
    commit(types.SET_ORDER_DATA, val);
  },

  /**
   * @description 更新 specsid
   * @param { Object } param0 操作对象
   * @param { Boolean } val 更新数据
   */
  updateSpecsId({ commit }, val) {
    commit(types.SET_ORDER_SPECSID, val);
  },

  /**
   * @description 更新 info
   * @param { Object } param0 操作对象
   * @param { Boolean } query 更新数据
   */
  updateInfo({ commit }, query) {
    commit(types.SET_ORDER_INFO, query);
  },

  /**
   * @description 更新用户格隆币
   * @param { Object } param0 操作对象
   * @param { Boolean } query 更新数据
   */
  updateCoin({ commit }, query) {
    commit(types.SET_USER_COIN, query);
  },

  /**
   * @description 获取收货地址
   */
  async getAddress({ commit }) {
    const obj = {};
    let data = await axios(getUserAddress());
    data = data.data;
    if (data.result) {
      const { state, city, phoneNum, name } = data.result;
      let { address } = data.result;
      let dist = '';
      if (address) {
        const index = address.indexOf('区');
        if (index > -1) {
          dist = address.slice(0, index + 1);
          address = address.slice(index + 1);
        }
      }
      obj.address = {
        name,
        phone: phoneNum,
        address,
        temp: {
          state,
          city,
          dist,
        },
      };
      commit(types.SET_ORDER_INFO, obj);
    }
  },

  /**
   * @description 获取商品价格
   * @param { Object } param0 操作对象
   */
  async getGoodsPayment({ state, commit, dispatch }, changeCoupon = true) {
    const obj = {};
    const arr = [state.specsId];
    if (state.info.memberSpecsId) {
      arr.push(state.info.memberSpecsId);
    }
    const noNeedCoupon =
      !state?.info?.chooseCoupon?.couponId && !state.info.memberSpecsId;
    const couponId = state.info.memberSpecsId
      ? ''
      : state?.info?.chooseCoupon?.couponId || '';
    let data = await axios(
      getMemberGoodsPayment(arr, couponId, noNeedCoupon || null)
    );
    data = data.data;
    if (data.result) {
      obj.payInfo = data.result;
      if (state.info.memberSpecsId) {
        const coupons = await axios(
          getGoodsCoupinsList(obj.payInfo.packageSpecsId)
        );
        obj.couponList = coupons.data.result || [];
        if (changeCoupon) {
          if (data.result.couponInfo && data.result.couponInfo.coupon) {
            obj.chooseCoupon = Object.assign({}, data.result.couponInfo.coupon);
          } else {
            obj.chooseCoupon = '';
          }
        }
      }
      commit(types.SET_ORDER_INFO, obj);
    } else {
      commit(types.SET_ORDER_INFO, {
        memberSpecsId: null,
      });
      dispatch('getGoodsPayment');
      return data.message;
    }
  },

  /**
   * @description 生成订单
   * @param { Object } param0 操作对象
   * @param { Object } param1 请求参数
   */
  async createOrder(
    { dispatch, commit },
    { specsId, onlyVip = false, goodsId }
  ) {
    const obj = {};
    const userData = await axios(getMemberInfo());
    const userInfo = userData.data.result;
    if (userInfo) {
      dispatch('updateCoin', userInfo.account.coin || 0);
    }
    const vipInfo = await axios(vipList());
    if (vipInfo.data.result) {
      obj.vipGoodId =
        vipInfo.data.result.vip && vipInfo.data.result.vip.specsId;
    }
    let data;
    if (specsId) {
      data = await axios(getGoodsDetail(specsId, onlyVip));
    } else {
      for (const item of goodsId) {
        const orderItem = await axios(getGoodsDetail(item, onlyVip));
        if (!data) {
          data = orderItem;
        } else {
          data.data.result.goods[0].purchaseInfos.unshift(
            orderItem.data.result.goods[0].purchaseInfos[0]
          );
        }
      }
    }
    data = data.data;
    obj.userToken = getCookie('user_token');
    if (data.statusCode === 200) {
      const { goods } = data.result;
      commit(types.SET_ORDER_DATA, data.result);
      if (goods) {
        commit(types.SET_ORDER_SPECSID, goods[0].purchaseInfos[0].specsId);
        obj.memberPrice = goods[0].purchaseInfos[0].price;
        obj.couponList = goods[0].purchaseInfos[0].coupons || [];
        obj.vipDiscount = goods[0].purchaseInfos[0].vipDiscount;
        obj.displayButtonText = goods[0].purchaseInfos[0].displayButtonText;
        if (obj.couponList.length > 0) {
          // 如果存在优惠券则选择第一个优惠券
          obj.chooseCoupon = Object.assign({}, obj.couponList[0]);
        }
      }
      commit(types.SET_ORDER_INFO, obj);
      dispatch('getAddress');
      dispatch('getGoodsPayment');
      commit(types.SET_ORDER_SHOW, true);
    } else if (data.statusCode === 1012) {
      const { nick, avatar } = userInfo;
      const bindWechatInfo = {
        nick,
        avatar,
      };
      // 1012 需要绑定手机号
      commit(
        `user/${types.SHOW_LOGIN_FORM}`,
        { bindWechatInfo },
        { root: true }
      );
    } else {
      return data.message;
    }
  },

  /**
   * @description 关闭弹窗
   * @param {*} param0 操作对象
   */
  closeDialog({ dispatch }) {
    dispatch('updateInfo', {
      chooseCoupon: '',
      couponList: [],
      vipDiscount: null,
      vipGoodId: null,
      displayButtonText: null,
      memberPrice: 0,
      payInfo: {
        // 商品结算数据
        goods: [],
        packageSpecsId: null, // 实际结算商品
        total: null, // 应付金额
        vipDiscount: null, // 会员减免优惠
      },
      paymethod: 'wechat', // 支付方法默认微信
      memberSpecsId: null,
      userToken: '',
      publicKey: '4zG9ZXqTQCX6vJqMLeVHAJHQ6sePEPwM',
      address: {
        name: '',
        phone: '',
        address: '',
        temp: {
          state: '',
          city: '',
          dist: '',
        },
      },
    });
    dispatch('updateData', null);
    dispatch('updateSpecsId', null);
    dispatch('updateShowStatus', false);
    dispatch('updateCoin', 0);
  },
};
